import { ADD_USER_SUCCESS, ADD_USER_ERROR, EDIT_USER_ERROR, EDIT_USER_SUCCESS } from '../../../actions'

const defaultState = {
  success: false,
  error: false,
}

export const addUser = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_USER_SUCCESS:
      return { ...state, success: true, error: false }
    case ADD_USER_ERROR:
      return { ...state, success: false, error: true }
    default:
      return state
  }
}

export const editUser = (state = defaultState, action) => {
  switch (action.type) {
    case EDIT_USER_SUCCESS:
      return { ...state, success: true, error: false }
    case EDIT_USER_ERROR:
      return { ...state, success: false, error: true }
    default:
      return state
  }
}
